import axios from 'axios';
import { showAlert } from './alerts.js';

// Create httpx object with common HTTP methods
export const httpx = {
  get: async (url, config = {}) => {
    return axios({
      method: 'GET',
      url,
      withCredentials: true,
      ...config,
    });
  },
  post: async (url, data = {}, config = {}) => {
    return axios({
      method: 'POST',
      url,
      data,
      withCredentials: true,
      ...config,
    });
  },
  patch: async (url, data = {}, config = {}) => {
    return axios({
      method: 'PATCH',
      url,
      data,
      withCredentials: true,
      ...config,
    });
  },
  delete: async (url, config = {}) => {
    return axios({
      method: 'DELETE',
      url,
      withCredentials: true,
      ...config,
    });
  },
};

export const softDelete = async id => {
  try {
    showAlert(
      'success',
      `User Deleted!, but not realy, this is a demo :p`,
      //`${type.toUpperCase()} User Deleted!, but not realy, this is a demo :p`,
    );
  } catch (err) {
    showAlert('error', 'error'); //err.response.data.message);
  }
};

export const login = async (email, password) => {
  try {
    const res = await axios({
      method: 'POST',
      url: `/api/v1/users/login`,
      data: {
        email,
        password,
      },
      withCredentials: true,
    });

    if (res.data.status === 'success') {
      showAlert('success', 'Logged in successfully!');
      window.setTimeout(() => {
        location.assign('/');
      }, 1500);
    }
  } catch (err) {
    showAlert('error', err.response.data.message);
  }
};

export const logout = async () => {
  try {
    const res = await axios({
      method: 'POST',
      url: `/api/v1/users/logout`,
      timeout: 5000,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (res.data.status === 'success') {
      localStorage.removeItem('impMenuShown');
      window.location.href = '/';
    }
  } catch (err) {
    console.log('Logout error:', err.message);
    localStorage.removeItem('impMenuShown');
    location.assign('/');
    showAlert(
      'error',
      'Logged out with some errors, but you have been redirected safely.',
    );
  }
};

export const requestReset = async email => {
  try {
    const res = await axios({
      method: 'POST',
      url: '/api/v1/users/forgotPassword',
      data: {
        email,
      },
    });

    if (res.data.status === 'success') {
      showAlert('success', 'reset link is send!');
      window.setTimeout(() => {
        location.assign('/');
      }, 1500);
    }
  } catch (err) {
    showAlert('error', err.response.data.message);
  }
};

export const resetPassword = async (password, passwordConfirm, token) => {
  try {
    const res = await axios({
      method: 'PATCH',
      url: `/api/v1/users/resetPassword/${token}`,
      data: {
        password,
        passwordConfirm,
      },
    });

    if (res.data.status === 'success') {
      showAlert('success', 'reset Complete!');
      window.setTimeout(() => {
        location.assign('/');
      }, 1500);
    }
  } catch (err) {
    showAlert('error', err.response.data.message);
  }
};

export const updateOrCreateRecord = async (data, url, method, type) => {
  console.error('---->', data, url, method, type);
  try {
    const res = await axios({
      method,
      url,
      data,
    });
    if (res.data.status === 'success') {
      showAlert('success', `${type.toUpperCase()} updated successfully!`);
    }
    return 'succes';
  } catch (err) {
    showAlert('error', err.response.data.message);
  }
};
